const STORAGE_KEY = 'dwellia_feature_config_v1';
export const CONFIG_UPDATED_EVENT = 'dwellia-config-updated';

const DEFAULT_CONFIG = {
  hideCrimeOverlay: false,
  hideSafetyScore: false,
  hideAffordabilityScore: false,
  hideLivabilityScore: false,
  hideFurnishedFinder: false,
};

function normalizeConfig(value) {
  return {
    ...DEFAULT_CONFIG,
    ...(value && typeof value === 'object' ? value : {}),
  };
}

export function getFeatureConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_CONFIG };
    return normalizeConfig(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_CONFIG };
  }
}

export function setFeatureConfig(nextConfig) {
  const normalized = normalizeConfig(nextConfig);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new CustomEvent(CONFIG_UPDATED_EVENT, { detail: normalized }));
  return normalized;
}

export async function fetchFeatureConfig() {
  if (process.env.NODE_ENV === 'development') {
    return Promise.resolve(getFeatureConfig());
  }
  try {
    const response = await fetch('/api/feature-config', { cache: 'no-store' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = normalizeConfig(await response.json());
    return setFeatureConfig(data);
  } catch {
    return getFeatureConfig();
  }
}

export async function saveFeatureConfig(nextConfig, password) {
  const response = await fetch('/api/feature-config', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ config: normalizeConfig(nextConfig), password }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return setFeatureConfig(data);
}
